import { render, staticRenderFns } from "./DepartmentMembers.vue?vue&type=template&id=129ef6e9"
import script from "./DepartmentMembers.vue?vue&type=script&lang=ts"
export * from "./DepartmentMembers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports